// src/components/ActionIconButton.jsx
import { IconButton, Tooltip, useTheme } from "@mui/material";
import { tokens } from "../theme/tokens";

const ActionIconButton = ({
  title,
  tone = "teal",
  children,
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const tones = {
    teal: colors.scalpelTeal[400],
    gold: colors.houndGold[400],
    danger: colors.softRed[400],
    ghost: colors.text.secondary,
  };

  const color = tones[tone] || tones.teal;

  return (
    <Tooltip title={title}>
      <span>
        <IconButton
          size="small"
          {...props}
          sx={{
            width: 34,
            height: 34,
            borderRadius: 2,
            color,
            bgcolor: "transparent",
            border: `1px solid ${colors.surface.border}`,
            transition:
              "background-color 180ms ease, border-color 180ms ease, transform 180ms ease, box-shadow 180ms ease",
            "&:hover": {
              bgcolor: colors.surface.elevated,
              borderColor: color,
              transform: "translateY(-1px)",
              boxShadow: "0 10px 22px rgba(0,0,0,0.24)",
            },
            "&.Mui-disabled": {
              color: colors.text.muted,
              borderColor: colors.surface.border,
              bgcolor: "transparent",
            },
            ...sx,
          }}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ActionIconButton;